// @flow

import type { Site, PartnerSupport, SalesPerson, Bounds } from './types';
import type { JSONObject, JSONValue } from 'common/types';
import {
  object,
  record,
  string,
  number,
  boolean,
  nullable
} from 'common/json/extract';

type SitesJSON = { [key: string]: JSONObject, ... };
const sitesJSON: SitesJSON = require('railsRoot/config/sites.json');

export default function allSites(): Array<Site> {
  return Object.keys(sitesJSON).map(key => {
    return siteFromJSON(key, sitesJSON[key]);
  });
}

const extractPartnerSupport: JSONValue => PartnerSupport = object(
  record({
    mail: string,
    phone: nullable(string)
  })
);

const extractSalesPerson: JSONValue => SalesPerson = object(
  record({
    team_mail: string,
    first_name: string,
    image: string,
    mail: string,
    name: string,
    phone: nullable(string)
  })
);

const requiredBounds: JSONValue => Bounds = object(
  record({
    south: number,
    west: number,
    north: number,
    east: number
  })
);

function siteFromJSON(key: string, json: JSONObject): Site {
  return {
    key: key,
    locale: requiredString(json.locale),
    baseDomain: requiredString(json.base_domain),
    countryInPath: optionalString(json.country_in_path),
    alwaysBypassConversations: boolean(json.always_bypass_conversations),
    alwaysSkipVenueReviewNotifications: boolean(
      json.always_skip_venue_review_notifications
    ),
    twitterHandle: optionalString(json.twitter_handle),
    facebookHandle: optionalString(json.facebook_handle),
    partnersUrl: optionalString(json.partners_url),
    defaultOgImage: optionalString(json.default_og_image),
    defaultSearchBounds: requiredBounds(json.default_search_bounds),
    defaultMapCenter: requiredLocation(json.default_map_center),
    iso31661Alpha2: optionalString(json.iso_3166_1_alpha_2),
    iso31661Alpha3: optionalString(json.iso_3166_1_alpha_3),
    partnerSupport: extractPartnerSupport(json.partner_support),
    salesPerson: extractSalesPerson(json.sales_person)
  };
}

function requiredString(maybeString): string {
  if (typeof maybeString !== 'string') {
    throw new Error(
      `Expected string, got ${typeof maybeString}: ${String(maybeString)}`
    );
  }
  return maybeString;
}

function optionalString(maybeString): string | null {
  if (typeof maybeString !== 'string') {
    return null;
  }
  return maybeString;
}

function requiredLocation(maybeLocation): [number, number] {
  /* $FlowFixMe */
  return maybeLocation;
}
